import AssetsTable from "./table";

const Assets = () => {
  return <AssetsTable />;
};

export default Assets;
